<template>
  <td>
    <template v-if="itemData">
      {{ itemData }}
    </template>
    <template v-else>
      <v-chip label outlined color="error">No data</v-chip>
    </template>
  </td>
</template>
<script>
export default {
  props: {
    itemData: {
      type: [String, Boolean, Number],
      required: true
    }
  }
};
</script>
